export const PAGE_SET_MANY = 'PAGE_SET_MANY';
export const PAGE_UPDATE_MANY = 'PAGE_UPDATE_MANY';
export const SET_PAGE_IS_COMMENT_REQUIRED = 'SET_PAGE_IS_COMMENT_REQUIRED';
export const SET_PAGE_SUBPAGE_LIST = 'SET_PAGE_SUBPAGE_LIST';
export const CREATE_PAGE_SUCCESS = 'CREATE_PAGE_SUCCESS';
